import React, { useMemo } from "react";
import { Box, Card, Code, Container, Stack, Text, Title } from "@mantine/core";
import { DeckBimViewer } from "@multiconsult-group/multiplacer-ui";
import type { IPixPolygon } from "@multiconsult-group/multiplacer-ui";

const PIX_BIM_DEBUG_POLYGONS: IPixPolygon[] = [
  {
    id: "section-2YoSozQhvFH8ohWofLavZe",
    entityId: "69b193dfbdffec9292d8f3d9",
    points: [
      [111951.83792048322, 1217006.6867528167],
      [111951.78113740536, 1217007.1342158383],
      [111951.72499029254, 1217007.1270907673],
      [111951.7817733704, 1217006.6796277456],
      [111951.83792048322, 1217006.6867528167],
    ],
    fillColor: "#74c0fc",
    strokeColor: "#1971c2",
    strokeWidth: "2",
    opacity: 0.45,
    text: {
      values: ["Stol Klap Vaeghaengt Loes:Stol, klapp loos vegghengt:50024939"],
      color: "#0b2239",
      fontSize: "1",
      show: false,
    },
    tooltip: "Stol Klap Vaeg haengt Loes:Stol, klapp loos vegghengt:50024939\nIfcFurniture",
    isMoveable: false,
    isDragSelectable: false,
    isNotClickable: false,
  },
  {
    id: "section-2YoSozQhvFH8ohWofLavZl",
    entityId: "69b193dfbdffec9292d8f3d8",
    points: [
      [111951.78308280274, 1217006.6299229062],
      [111951.64460331008, 1217007.7211714708],
      [111951.63964308934, 1217007.7205420185],
      [111951.77812258199, 1217006.6292934539],
      [111951.78308280274, 1217006.6299229062],
    ],
    fillColor: "#74c0fc",
    strokeColor: "#1971c2",
    strokeWidth: "2",
    opacity: 0.45,
    text: {
      values: ["Bagplade2:Koffertskap med bakplate b=1100 - FSA.083.06:50024940"],
      color: "#0b2239",
      fontSize: "1",
      show: false,
    },
    tooltip: "Bagplade2:Koffertskap med bakplate b=1100 - FSA.083.06:50024940\nIfcFurniture",
    isMoveable: false,
    isDragSelectable: false,
    isNotClickable: false,
  },
  {
    id: "section-2YoSozQhvFH8ohWofLavZj",
    entityId: "69b193dfbdffec9292d8f3d6",
    points: [
      [111951.83119495526, 1217007.1652386584],
      [111951.76636137458, 1217007.676141396],
      [111951.65215673749, 1217007.6616488222],
      [111951.71699031816, 1217007.1507460847],
      [111951.83119495526, 1217007.1652386584],
    ],
    fillColor: "#74c0fc",
    strokeColor: "#1971c2",
    strokeWidth: "2",
    opacity: 0.45,
    text: {
      values: ["Stol Kuffert Foldet b515:Koffertstativ:50024942"],
      color: "#0b2239",
      fontSize: "1",
      show: false,
    },
    tooltip: "Stol Kuffert Foldet b515:Koffertstativ:50024942\nIfcFurniture",
    isMoveable: false,
    isDragSelectable: false,
    isNotClickable: false,
  },
  {
    id: "section-2YoSozQhvFH8ohWofLavZf",
    entityId: "69b193dfbdffec9292d8f3da",
    points: [
      [111951.66455725791, 1217007.5639300134],
      [111951.68104828229, 1217007.4339771494],
      [111951.73065048982, 1217007.4402716716],
      [111951.71415946544, 1217007.5702245357],
      [111951.66455725791, 1217007.5639300134],
    ],
    fillColor: "#74c0fc",
    strokeColor: "#1971c2",
    strokeWidth: "2",
    opacity: 0.45,
    text: {
      values: ["Knage dobbel:Knagg dobbel:50024938"],
      color: "#0b2239",
      fontSize: "1",
      show: false,
    },
    tooltip: "Knage dobbel:Knagg dobbel:50024938\nIfcFurniture",
    isMoveable: false,
    isDragSelectable: false,
    isNotClickable: false,
  },
  {
    id: "section-2YoSozQhvFH8ohWofLavZk",
    entityId: "69b193dfbdffec9292d8f3d7",
    points: [
      [111951.72928434215, 1217007.2921689241],
      [111951.72928434215, 1217007.2921689241],
      [111951.72928434215, 1217007.2921689241],
      [111951.72928434215, 1217007.2921689241],
      [111951.72928434215, 1217007.2921689241],
    ],
    fillColor: "#74c0fc",
    strokeColor: "#1971c2",
    strokeWidth: "2",
    opacity: 0.45,
    text: {
      values: ["Knageraekke:Veggoppheng koffertstativ:50024941"],
      color: "#0b2239",
      fontSize: "1",
      show: false,
    },
    tooltip: "Knageraekke:Veggoppheng koffertstativ:50024941\nIfcFurniture",
    isMoveable: false,
    isDragSelectable: false,
    isNotClickable: false,
  },
];

export const PixBimDebugPage: React.FC = () => {
  const zoomExtentKey = useMemo(
    () =>
      `pixbim-debug:${PIX_BIM_DEBUG_POLYGONS.length}:${PIX_BIM_DEBUG_POLYGONS.map(
        (polygon) => polygon.id
      ).join("|")}`,
    []
  );

  return (
    <Container size="xl" py="xl">
      <Stack gap="md">
        <Stack gap={4}>
          <Title order={2}>PixBim debug</Title>
          <Text c="dimmed" size="sm">
            Frittstaende testside for aa verifisere zoom extent, rendering og polygondata.
          </Text>
        </Stack>

        <Card withBorder radius="md" p="md">
          <Stack gap="xs">
            <Text fw={600}>Debugdata</Text>
            <Text size="sm" c="dimmed">
              Antall polygoner: {PIX_BIM_DEBUG_POLYGONS.length}
            </Text>
            <Code block>{`Route: /pixbimdebu`}</Code>
          </Stack>
        </Card>

        <Card withBorder radius="md" p="md">
          <Stack gap="sm">
            <Text fw={600}>Viewer</Text>
            <Box h={640} w="100%">
              <DeckBimViewer
                flip2dCoordinate={true}
                angle={0}
                paths={[]}
                polygons={PIX_BIM_DEBUG_POLYGONS}
                zoomExtentKey={zoomExtentKey}
              />
            </Box>
          </Stack>
        </Card>
      </Stack>
    </Container>
  );
};
